import { Box, Typography, useMediaQuery } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomerAdminUsersCard from './CustomerAdminUsersCard'
import { customerAdminSelectUsers } from '../../../redux/features/users/customerAdmin/customerAdminSlice'
import {
  retrieveCustomerAdminUsers,
  customerAdminResetAlertHandler,
} from '../../../redux/features/users/customerAdmin/customerAdminThunk'
import CookiesStorageService from '../../../services/CookiesStorageService'
import PageFilter from './PageFilters/index'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import LoaderWithErrorHandler from '../../../components/PageHelpers/LoaderWithErrorHandler.jsx'
import SearchBarV2 from '../../../components/PageHelpers/SearchBarV2.jsx'

const Index = () => {
  const username = CookiesStorageService.getUserName()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const dispatch = useDispatch()
  const customerAdminUsers = useSelector(customerAdminSelectUsers)
  const { t } = UseTranslation()
  useEffect(() => {
    dispatch(retrieveCustomerAdminUsers({ queries: { pageNumber: 0 }, resetQueries: true }))
  }, [])
  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleBox}>
        <Typography sx={styles.welcomeHeader}>{t?.Welcome} , {username}</Typography>
        {!isXsScreen && (<SearchBarV2
          actionToDispatch={retrieveCustomerAdminUsers}
          searchPlaceholder={t?.['Search for user by username or Email Address']}
          customStyles={styles.searchBarContainer}
          sendQueryAsObject
          actionProps={{ pageNumber: 0 }}
        />)}
      </Box>
      <PageFilter />

          <CustomerAdminUsersCard />

       <LoaderWithErrorHandler
          store={customerAdminUsers}
          resetAlertHandler={customerAdminResetAlertHandler}
        />

    </Box>
  )
}

const styles = {
  container: {
    padding: { xs: '10px 20px', sm: '0 70px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    svg: {
      fontSize: { xs: '20px', sm: 'unset' },
      marginTop: { xs: '10px', sm: 'unset' },
    },
  },
  welcomeHeader: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  searchBarContainer: {
    paddingTop: { xs: '10px', sm: 'unset' },
    input: {
      fontSize: { xs: '11px', sm: 'unset' },
    },
  },
}

export default Index
